import { render } from "./DefenseDesktop.vue?vue&type=template&id=37a497a0"
import script from "./DefenseDesktop.vue?vue&type=script&lang=js"
export * from "./DefenseDesktop.vue?vue&type=script&lang=js"

import "./DefenseDesktop.vue?vue&type=style&index=0&id=37a497a0&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__